import React, { useState, useEffect } from 'react';
import { storage, firestore } from './firebaseConfig';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';

const GalleryInput = () => {
  const [mediaFiles, setMediaFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [mediaItems, setMediaItems] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    const fetchMediaItems = async () => {
      const galleryCollection = collection(firestore, 'gallery');
      const gallerySnapshot = await getDocs(galleryCollection);
      setMediaItems(gallerySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchMediaItems();
  }, []);

  const handleAddMedia = async () => {
    if (mediaFiles.length > 0) {
      setUploading(true);
      setUploadProgress(0);
      setUploadSuccess(false);
      try {
        let uploadedCount = 0;
        const totalFiles = mediaFiles.length;

        const uploadPromises = mediaFiles.map(async (file) => {
          const storageRef = ref(storage, `gallery/${file.name}`);
          const uploadTask = uploadBytesResumable(storageRef, file);

          uploadTask.on('state_changed', 
            (snapshot) => {
              // Calculate progress for each file
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setUploadProgress((prev) => prev + progress / totalFiles);
            },
            (error) => {
              console.error('Error uploading media:', error);
            },
            async () => {
              // Get the download URL once the upload is complete
              const mediaUrl = await getDownloadURL(uploadTask.snapshot.ref);

              // Add document to Firestore
              await addDoc(collection(firestore, 'gallery'), {
                mediaUrl,
                mediaType: file.type.includes('video') ? 'video' : 'image',
              });

              // Track uploaded count
              uploadedCount++;
              if (uploadedCount === totalFiles) {
                setUploadSuccess(true);  // All files uploaded
                setUploading(false);
                setMediaFiles([]); // Reset media input
              }
            }
          );
        });

        await Promise.all(uploadPromises);
      } catch (error) {
        console.error('Error uploading media:', error);
      }
    }
  };

  const handleDeleteMedia = async (id) => {
    if (window.confirm('Are you sure you want to delete this media item?')) {
      try {
        await deleteDoc(doc(firestore, 'gallery', id));
        setMediaItems(mediaItems.filter(item => item.id !== id));
      } catch (error) {
        console.error('Error deleting media:', error);
      }
    }
  };

  return (
    <div>
      <h2>Add Media to Gallery</h2>
      <input
        type="file"
        accept="image/*,video/*"
        multiple
        onChange={(e) => setMediaFiles([...e.target.files])}
      />
      <button onClick={handleAddMedia} disabled={uploading}>
        {uploading ? 'Uploading...' : 'Add Media'}
      </button>

      {uploading && (
        <div>
          <progress value={uploadProgress} max="100" style={{ width: '100%' }} />
          <p>Uploading {Math.round(uploadProgress)}%</p>
        </div>
      )}

      {uploadSuccess && !uploading && (
        <div>
          <p>All items uploaded successfully!</p>
        </div>
      )}

      <h3>Existing Media</h3>
      {mediaItems.length === 0 ? (
        <p>No media added yet.</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {mediaItems.map(item => (
            <div key={item.id} style={{ border: '1px solid #ddd', padding: '10px' }}>
              {item.mediaType === 'video' ? (
                <video src={item.mediaUrl} width="150" controls />
              ) : (
                <img src={item.mediaUrl} alt="Uploaded" width="150" />
              )}
              <p>{item.mediaType}</p>
              <button onClick={() => handleDeleteMedia(item.id)}>Delete</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GalleryInput;
